var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FC686E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.55 7.2H17.05L13.55 11.2L17.6 16.8H14.55L11.95 13.35L8.85 16.8H7.35L11.05 12.5L7 7.2H10.15L12.5 10.4L15.55 7.2ZM14.95 15.65H15.9L9.75 8.25H8.75L14.95 15.65Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.0c0a8ea9981510b4169c8b99df2d0a6e.svg";
export { ForwardRef as ReactComponent };